import Telemetry from '@atlassian/mpac-telemetry';
export const viewAppDetailsTask = 'view-app-details';
export const AppListingTask = Telemetry.createGenericTask(viewAppDetailsTask);